import fromPairs from 'lodash-es/fromPairs';
import isString from 'lodash-es/isString';
import toPairs from 'lodash-es/toPairs';

export function registerMany(app, stores) {
    stores.forEach(store => app.registerStore(store));
}

/**
 * Create multiple action creators. If the definition of actionCreator is just string, it is used as action name
 * that is dispatched by that actionCreator. If definition is a function, it is unaltered and used
 * @arg {Object} actions - pairs of {actionCreator: action name} or {actionCreator: function}
 */
export function makeActionCreators(actionCreators) {
    return fromPairs(toPairs(actionCreators).map(pair => {
        let [key, val] = pair;
        if (isString(val)) {
            val = (context, data, done) => {
                context.dispatch(pair[1], data);
                done();
            };
        }
        return [key, val];
    }));
}
